import { render, staticRenderFns } from "./EditProductSidebar.vue?vue&type=template&id=5bc0615e"
import script from "./EditProductSidebar.vue?vue&type=script&lang=js"
export * from "./EditProductSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports